import { useState } from 'react';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import SmallModal from '../global/SmallModal';
import { REDESIGN_REVERT_REASONS } from '../../constants/redesign';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<unknown>;
  isSaving: boolean;
}

function RedesignRevertDialog({ open, onClose, onConfirm, isSaving }: Props) {
  const [reason, setReason] = useState('');
  const [details, setDetails] = useState('');

  const combined = [reason, details.trim()].filter(Boolean).join(': ');

  return (
    <SmallModal
      open={open}
      onClose={onClose}
      title="Switch back to classic?"
      footer={{
        button: {
          type: 'button',
          text: 'Switch back',
          disabled: !reason,
          loading: isSaving,
          onClick: async () => {
            await onConfirm(combined);
          },
        },
      }}>
      <Stack p={2} gap={1.5}>
        <Typography variant="body2" color="text.secondary">
          Tell us what sent you back so we can fix it. You can return to the new
          design anytime from Settings.
        </Typography>
        <RadioGroup value={reason} onChange={e => setReason(e.target.value)}>
          {REDESIGN_REVERT_REASONS.map(option => (
            <FormControlLabel
              key={option}
              value={option}
              control={<Radio size="small" />}
              label={<Typography variant="body2">{option}</Typography>}
            />
          ))}
        </RadioGroup>
        <TextField
          size="small"
          multiline
          minRows={2}
          placeholder="Anything else? (optional)"
          value={details}
          onChange={e => setDetails(e.target.value)}
          inputProps={{ maxLength: 400 }}
        />
      </Stack>
    </SmallModal>
  );
}

export default RedesignRevertDialog;
